import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import ProtectedRoutes from './ProtectedRoutes';
import PublicRoutes from './PublicRoutes';
import Login from '../modules/auth/Login';
import Register from '../modules/auth/Register';
import ResetPassword from '../modules/auth/ResetPassword';
import ChangePassword from '../modules/auth/ChangePassword';
import DiscordCallback from '../modules/auth/DiscordCallback';
import GoogleCallback from '../modules/auth/GoogleCallback';
import VerifyEmail from '../modules/auth/VerifyEmail';

import Dashboard from '../modules/admin/dashboard/Dashboard';
import Roles from '../modules/admin/rules/Rules';
import Users from '../modules/admin/users/Users';
import AdminServers from '../modules/admin/servers/Servers';
import AdminVideos from '../modules/admin/videos/Videos';
import AdminContentCreators from '../modules/admin/contentCreators/ContentCreators';
import AdminShopItems from '../modules/admin/shopItems/ShopItems';
import AdminShopItemOffers from '../modules/admin/shopItemOffers/ShopItemOffers';
import AdminTransactions from '../modules/admin/transactions/Transactions';
import AdminServices from '../modules/admin/services/Services';
import AdminSettings from '../modules/admin/settings/Settings';
import Home from '../modules/website/home';
import ServerDetails from '../modules/website/serverDetails';
import TopList from '../modules/website/topList';
import NewServers from '../modules/website/newServers';
import Videos from '../modules/website/videos';
import ContentCreators from '../modules/website/contentCreators';
import Shop from '../modules/website/shop';
import AddShopItemPage from '../modules/website/shop/AddShopItemPage';
import MyShopItemsPage from '../modules/website/shop/MyShopItemsPage';
import Services from '../modules/website/services';
import UserProfile from '../modules/website/profile';
import Wallet from '../modules/website/wallet';
import AddServer from '../modules/website/addServer';
import AddVideo from '../modules/website/addVideo';
import Programmers from '../modules/website/programmers';
import TalentDetails from '../modules/website/talentDetails';
import AddProgrammer from '../modules/website/addProgrammer';
import AddDesigner from '../modules/website/addDesigner';
import AddBetaTester from '../modules/website/addBetaTester';
import PixelBuilder from '../modules/website/pixelBuilder';
import YoutubeTool from '../modules/website/youtubeTool';
import AdminTalents from '../modules/admin/talents/Talents';

const Navigation = () => {
  const auth = useSelector(state => state.auth);

  const permissions = auth.user?.role?.permissions ?? [];

  return (
    <Routes>
      <Route element={<PublicRoutes />}>
        <Route path='' element={<Home />} />
        <Route path='server/:id' element={<ServerDetails />} />
        <Route path='top-list' element={<TopList />} />
        <Route path='new-servers' element={<NewServers />} />
        <Route path='videos' element={<Videos />} />
        <Route path='content-creators' element={<ContentCreators />} />
        <Route path='shop' element={<Shop />} />
        <Route path='add-shop-item' element={<AddShopItemPage />} />
        <Route path='my-shop-items' element={<MyShopItemsPage />} />
        <Route path='services' element={<Services />} />
        <Route path='profile' element={<UserProfile />} />
        <Route path='wallet' element={<Wallet />} />
        <Route path='add-server' element={<AddServer />} />
        <Route path='add-video' element={<AddVideo />} />
        <Route path='archive' element={<Navigate to="/new-servers?tab=archive" replace />} />
        <Route path='programmers' element={<Programmers />} />
        <Route path='talent/:id' element={<TalentDetails />} />
        <Route path='designers' element={<Navigate to="/programmers?tab=designer" replace />} />
        <Route path='beta-testers' element={<Navigate to="/programmers?tab=beta_tester" replace />} />
        <Route path='add-programmer' element={<AddProgrammer />} />
        <Route path='add-designer' element={<AddDesigner />} />
        <Route path='add-beta-tester' element={<AddBetaTester />} />
        <Route path='12x12-builder' element={<PixelBuilder />} />
        <Route path='youtube-tool' element={<YoutubeTool />} />
      </Route>
      <Route path='login' element={<Login />} />
      <Route path='register' element={<Register />} />
      <Route path='reset_password' element={<ResetPassword />} />
      <Route path='change_password' element={<ChangePassword />} />
      <Route path='verify_email' element={<VerifyEmail />} />
      <Route path='auth/discord/callback' element={<DiscordCallback />} />
      <Route path='auth/google/callback' element={<GoogleCallback />} />
      <Route element={<ProtectedRoutes />}>
        <Route path='admin' element={<Dashboard />} />
        <Route path='admin/roles' element={permissions.includes("manage_settings") ? <Roles /> : <h1>not allow</h1>} />
        <Route path='admin/users' element={permissions.includes("manage_users") ? <Users /> : <h1>not allow</h1>} />
        <Route path='admin/servers' element={permissions.includes("manage_servers") ? <AdminServers /> : <h1>not allow</h1>} />
        <Route path='admin/programmers' element={permissions.includes("manage_programmers") ? <AdminTalents category="programmer" /> : <h1>not allow</h1>} />
        <Route path='admin/designers' element={permissions.includes("manage_designers") ? <AdminTalents category="designer" /> : <h1>not allow</h1>} />
        <Route path='admin/beta-testers' element={permissions.includes("manage_beta_testers") ? <AdminTalents category="beta_tester" /> : <h1>not allow</h1>} />
        <Route path='admin/videos' element={permissions.includes("manage_videos") ? <AdminVideos /> : <h1>not allow</h1>} />
        <Route path='admin/content-creators' element={permissions.includes("manage_content_creators") ? <AdminContentCreators /> : <h1>not allow</h1>} />
        <Route path='admin/shop' element={permissions.includes("manage_shop") ? <AdminShopItems /> : <h1>not allow</h1>} />
        <Route path='admin/shop-offers' element={permissions.includes("manage_shop") ? <AdminShopItemOffers /> : <h1>not allow</h1>} />
        <Route path='admin/transactions' element={permissions.includes("manage_transactions") ? <AdminTransactions /> : <h1>not allow</h1>} />
        <Route path='admin/services' element={permissions.includes("manage_services") ? <AdminServices /> : <h1>not allow</h1>} />
        <Route path='admin/settings' element={permissions.includes("manage_settings") ? <AdminSettings /> : <h1>not allow</h1>} />
      </Route>
    </Routes>
  )
}

export default Navigation
